// defs
import { ISimulationInput } from "@defs/Utilities";
import { InputType } from "@utils/appsync/schema/API";
import { IStepper } from "@components/Stepper/Stepper.props";

export enum GLSimulationSteppersType {
    INPUT_JOURNAL_ENTRIES = "INPUT_JOURNAL_ENTRIES",
    ADD_DEFINIIONS_AND_MAPPINGS = "ADD_DEFINIIONS_AND_MAPPINGS",
}

export const GL_SIMULATION_STEPPERS: Array<IStepper<GLSimulationSteppersType>> = [
    {
        key: "INPUT_JOURNAL_ENTRIES",
        label: "Input Journal Entries",
        position: 0,
        type: GLSimulationSteppersType.INPUT_JOURNAL_ENTRIES,
        hasNext: true,
        enableNext: false,
        hasBack: false,
        isComplete: false,
        isActive: true,
        isSkip: false,
        isVisible: true,
    },
    {
        key: "ADD_DEFINIIONS_AND_MAPPINGS",
        label: "Add Definitions and/or Mappings",
        position: 1,
        type: GLSimulationSteppersType.ADD_DEFINIIONS_AND_MAPPINGS,
        hasNext: false,
        enableNext: false,
        hasBack: true,
        isComplete: false,
        isActive: false,
        isSkip: false,
        isVisible: true,
    },
];

export const GL_SIMULATION_SIMULATION_INPUTS: Array<ISimulationInput<InputType>> = [
    {
        inputId: 0,
        inputLabel: "Definitions",
        inputKey: InputType.allocation_definition,
        systemSelection: false,
    },
    {
        inputId: 1,
        inputLabel: "Mappings",
        inputKey: InputType.allocation_mapping,
        systemSelection: false,
    },
];
